import html2canvas from "html2canvas";

export default {
	data() {
		return {
			isCanvasImageLoading: false,
			isDownloadBtnVisible: false,
		}
	},

	methods: {
		download(url) {
			return new Promise((resolve, reject) => {
				let request = new XMLHttpRequest();
				request.responseType = "blob";
				request.open("GET", url);
				request.addEventListener("load", function () {
					resolve(request.response);
				});
				request.send();
			})
		},

		downloadChartToImage(el, filename) {
			if(this.isCanvasImageLoading) return ;
			this.isCanvasImageLoading = true;
			let options = {
				scrollY: -window.scrollY,
				allowTaint: true,
				useCORS: true,
				imageTimeout: 0,
				backgroundColor:"#ffffff",
				onclone(doc) {
					//change some html style for topic cloud.
					if (doc.getElementById("cloudCard")) {
						let card = doc.getElementById("cloudCard");
						let rectWidth = el.getBoundingClientRect().left + window.screenX;
						card.style.width = `${card.offsetWidth + rectWidth + 100}px`;
					}
				}
			};
			html2canvas(el, {...options})
				.then(canvas => {
					this.download(canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream"))
						.then(img => {
							this.isCanvasImageLoading = false;
							let url = URL.createObjectURL(img);
							let link = document.createElement("a");
							link.download = `${filename}.jpg`;
							link.href = url;
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
						});
				})
		},

		toggleDownloadBtn(event){
			this.isDownloadBtnVisible = event.type !=='mouseleave';
		}
	}
}

